// lib

import PropTypes from 'prop-types'

// components
import { Dropdown } from 'primereact/dropdown'

import { default as ControlsContainer } from '@aytm/app/stats/page/question-views/components/questions-custom/Controls'

const Controls = ({ model, data, collapsed, disabled, onToggle, onChange }) => {
  const itemTemplate = option =>
    option.disabled && option.icon == undefined ? (
      <span dangerouslySetInnerHTML={{ __html: option.text }}></span>
    ) : (
      <span className={`p-item-label p-lvl-${option.lvl || 0}`}>
        {option.icon ? <i className={`p-item-icon icon-aytmfd-${option.icon}`} /> : null}
        <span dangerouslySetInnerHTML={{ __html: option.text }}></span>
      </span>
    )
  const valueTemplate = (option, _props) =>
    option ? (
      <>
        {option.icon ? <i className={`p-item-icon icon-aytmfd-${option.icon}`} /> : null}
        <span dangerouslySetInnerHTML={{ __html: option.label || option.text }}></span>
      </>
    ) : (
      <span dangerouslySetInnerHTML={{ __html: _props.placeholder || 'Select...' }}></span>
    )

  return (
    <ControlsContainer model={model} data={data} collapsed={collapsed} onToggle={onToggle}>
      <div className="p-fluid p-col-12">
        <Dropdown
          className="p-dropdown-rounded"
          placeholder={data.controls.source.placeholder}
          value={model.source}
          options={data.controls.source.options}
          optionValue="key"
          optionLabel="text"
          itemTemplate={itemTemplate}
          valueTemplate={valueTemplate}
          fixedDropdownDir="bottom"
          disabled={disabled || data.controls.source.disabled}
          onChange={disabled || data.controls.source.disabled ? null : event => onChange('source', event.value)}
        />
      </div>
    </ControlsContainer>
  )
}

Controls.propTypes = {
  model: PropTypes.object,
  data: PropTypes.object,
  collapsed: PropTypes.bool,
  disabled: PropTypes.bool,
  onToggle: PropTypes.func,
  onChange: PropTypes.func
}

Controls.displayName = 'Controls'

export default Controls
